import {SINGLE_END_MONITOR} from '@/enmus/PageNames';
export default {
    component: () => import('@/views/dataReport/jsDataMonitor/singleEndMonitor/index.vue'),
    path: 'singleEndMonitor',
    name: SINGLE_END_MONITOR,
    meta: {
        title: '单端日志',
        name: SINGLE_END_MONITOR
    }
};
